import { MoreVertical, GraduationCap, Building2, FileDown, Shield, Key, ShieldAlert } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Badge } from '@/components/ui/badge';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';

interface ChatHeaderProps {
  title: string;
  onEditTitle: () => void;
  onDeleteChat: () => void;
  onExportPDF?: () => void;
  userPlan?: string;
  chatMode?: string;
}

import badgePN from '@/assets/badge-policia-nacional.png';
import badgeGC from '@/assets/badge-guardia-civil.png';

function getAssistantInfo(chatMode?: string, plan?: string) {
  const mode = chatMode || plan;
  
  if (mode === 'oposiciones_policia_nacional' || mode === 'policia-nacional') {
    return {
      label: 'Asistente Policía Nacional',
      image: badgePN,
      variant: 'default' as const,
    };
  }
  
  if (mode === 'oposiciones_iipp') {
    return {
      label: 'Asistente IIPP',
      icon: Key,
      variant: 'secondary' as const,
    };
  }

  if (mode === 'oposiciones_guardia_civil') {
    return {
      label: 'Asistente Guardia Civil',
      image: badgeGC,
      variant: 'default' as const,
    };
  }

  if (mode === 'oposiciones' || mode === 'oposiciones_c1') {
    return {
      label: mode === 'oposiciones_c1' ? 'Asistente C1' : 'Asistente Oposiciones',
      icon: GraduationCap,
      variant: 'secondary' as const,
    };
  }
  return {
    label: 'Asistente Funcionarios',
    icon: Building2,
    variant: 'outline' as const,
  };
}

export function ChatHeader({ title, onEditTitle, onDeleteChat, onExportPDF, userPlan, chatMode }: ChatHeaderProps) {
  const assistantInfo = getAssistantInfo(chatMode, userPlan);
  const IconComponent = assistantInfo.icon;

  return (
    <div className="border-b border-border bg-card px-3 sm:px-6 py-2.5 sm:py-4">
      <div className="flex items-center justify-between gap-2 max-w-4xl mx-auto">
        <div className="flex-1 min-w-0 flex items-center gap-2 sm:gap-3">
          <h1 className="text-base sm:text-xl font-semibold text-foreground truncate">
            {title || '(Sin título)'}
          </h1>
          <Badge variant={assistantInfo.variant} className="flex items-center gap-1.5 shrink-0">
            {assistantInfo.image ? (
              <img src={assistantInfo.image} alt="" className="h-3.5 w-3.5 object-contain" />
            ) : (
              assistantInfo.icon && <assistantInfo.icon className="h-3.5 w-3.5" />
            )}
            <span className="hidden md:inline">{assistantInfo.label}</span>
          </Badge>
        </div>
        
        <DropdownMenu>
          <DropdownMenuTrigger asChild>
            <Button variant="ghost" size="sm" className="h-8 w-8 p-0">
              <MoreVertical className="h-4 w-4" />
            </Button>
          </DropdownMenuTrigger>
          <DropdownMenuContent align="end">
            <DropdownMenuItem onClick={onEditTitle}>
              ✏️ Editar título
            </DropdownMenuItem>
            {onExportPDF && (
              <DropdownMenuItem onClick={onExportPDF}>
                <FileDown className="h-4 w-4 mr-2" />
                Exportar a PDF
              </DropdownMenuItem>
            )}
            <DropdownMenuSeparator />
            <DropdownMenuItem onClick={onDeleteChat} className="text-destructive">
              🗑️ Eliminar conversación
            </DropdownMenuItem>
          </DropdownMenuContent>
        </DropdownMenu>
      </div>
    </div>
  );
}
